import styled from 'styled-components';
import style from '!css-loader!./style.css';

// shame
const [[, css]] = style;
const rule = css.slice(7, -1);
const EllipsisStyle = styled.div([rule]);

export default EllipsisStyle;
